import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "ScoreboardCommand";
export const ScoreboardCommandService = {
	endpoint,
	getCommands: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetCommands/${id}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	updateSingleById: async (id: number, data: any) => await Service.updateSingleById(endpoint, id, data),
	/** One-shot event to the club's boards (broadcast as ReceiveCommand), e.g. Refresh or Update. */
	sendEvent: async (key: string, value: string, scoreboardId: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}`, {body: JSON.stringify({commandKey: key, commandValue: value, commandComplete: false, scoreboardId}), headers: {"Content-Type": "application/json"}, method: "POST"})
}
